import { combineReducers } from 'redux';
import usuarioReducer from './usuarioReducer';
import alertaReducer from './alertaReducer';
import snackReducer from './snackReducer';
import notificacionesReducer from './notificacionesReducer';
import tidReducer from './tidReducer';

export default combineReducers({
    usuario: usuarioReducer,
    alerta: alertaReducer,
    snack: snackReducer,
    notificaciones: notificacionesReducer,
    dataTid: tidReducer,
});